const WE_ACCEPT_PREFIX = "WeAccept";

export const WE_ACCEPT_CLASSES = {
  title: `${WE_ACCEPT_PREFIX}-title`,
  paymentMethods: `${WE_ACCEPT_PREFIX}-paymentMethods`,
  hideOnMobile: `${WE_ACCEPT_PREFIX}-hideOnMobile`,
};
